var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDashBoardCompetitorsIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.669 0H5.33C1.929 0 0 1.929 0 5.33V14.67C0 18.07 1.929 20 5.33 20H14.669C18.07 20 20 18.07 20 14.67V5.33C19.99 1.929 18.07 0 14.669 0Z",
    fill: "#D64040"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3 15.4283V14.7676C3 14.1602 3.11963 13.5588 3.35206 12.9977C3.58449 12.4365 3.92516 11.9267 4.35463 11.4972C4.7841 11.0677 5.29396 10.7271 5.85509 10.4946C6.41622 10.2622 7.01764 10.1426 7.625 10.1426C8.23236 10.1426 8.83378 10.2622 9.39491 10.4946C9.95604 10.7271 10.4659 11.0677 10.8954 11.4972C11.3248 11.9267 11.6655 12.4365 11.8979 12.9977C12.1304 13.5588 12.25 14.1602 12.25 14.7676V15.4283",
    stroke: "white",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.62497 10.1429C8.3259 10.1429 8.99812 9.86445 9.49376 9.36882C9.98939 8.87319 10.2678 8.20096 10.2678 7.50004C10.2678 6.79911 9.98939 6.12688 9.49376 5.63125C8.99812 5.13562 8.3259 4.85718 7.62497 4.85718C6.92404 4.85718 6.25182 5.13562 5.75619 5.63125C5.26056 6.12688 4.98212 6.79911 4.98212 7.50004C4.98212 8.20096 5.26056 8.87319 5.75619 9.36882C6.25182 9.86445 6.92404 10.1429 7.62497 10.1429V10.1429Z",
    stroke: "white",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12 12.9999V12.5624C12 12.1602 12.0792 11.7619 12.2331 11.3904C12.387 11.0188 12.6126 10.6812 12.897 10.3968C13.1814 10.1124 13.519 9.88679 13.8906 9.73288C14.2622 9.57897 14.6604 9.49976 15.0626 9.49976C15.4648 9.49976 15.863 9.57897 16.2346 9.73288C16.6062 9.88679 16.9438 10.1124 17.2282 10.3968C17.5126 10.6812 17.7382 11.0188 17.8921 11.3904C18.046 11.7619 18.1252 12.1602 18.1252 12.5624V12.9999",
    stroke: "white",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M15.0626 9.50013C15.5267 9.50013 15.9718 9.31575 16.3 8.98755C16.6282 8.65935 16.8126 8.21421 16.8126 7.75006C16.8126 7.28592 16.6282 6.84078 16.3 6.51258C15.9718 6.18438 15.5267 6 15.0626 6C14.5984 6 14.1533 6.18438 13.8251 6.51258C13.4969 6.84078 13.3125 7.28592 13.3125 7.75006C13.3125 8.21421 13.4969 8.65935 13.8251 8.98755C14.1533 9.31575 14.5984 9.50013 15.0626 9.50013V9.50013Z",
    stroke: "white",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashBoardCompetitorsIcon);
export default __webpack_public_path__ + "static/media/DashBoardCompetitorsIcon.a4d16403ab1e1d830fbd53dca21f9aa6.svg";
export { ForwardRef as ReactComponent };